<template>
  <div class="hospital">
    <input readonly class="input-btn" v-model="departmentVal" />
    <el-button class="click-btn" @click="openMask"></el-button>
    <transition name="el-zoom-in-bottom">
      <div class="mask-hospital" v-if="maskShow" @click="closeMask">
        <div class="hospital-content" @click.stop="">
          <div class="select">
            <span @click="closeMask(1)">清空</span>
            <span @click="confirmHoslital">确定</span>
          </div>
          <section class="title">
            <div
              class="area"
              :class="selectId == 0 ? 'on' : ''"
              @click="changeId(0)"
            >
              <span>{{ menuVal || "请选择" }}</span>
            </div>
            <div
              class="area"
              :class="selectId == 1 ? 'on' : ''"
              @click="changeId(1)"
            >
              <span v-show="menuVal">{{ departmentVal || "请选择" }}</span>
            </div>
          </section>
          <hr
            style="height:1px;border:none;border-top:1px solid rgb(216, 216, 216);"
          />
          <ul class="content">
            <transition name="slide-fade">
              <div v-show="showMenu">
                <li
                  v-for="(item, index) in menuList"
                  :key="index"
                  @click.stop="getMenuVal(item)"
                  :class="menuVal == item ? 'active' : ''"
                >
                  {{ item }}
                  <i v-if="menuVal == item" class="el-icon-check"></i>
                </li>
              </div>
            </transition>
            <transition name="slide-fade">
              <div v-show="showDepartment">
                <li
                  v-for="(item, index) in departmentList"
                  :key="index"
                  @click.stop="getDepartmentVal(item)"
                  :class="departmentVal == item ? 'active' : ''"
                >
                  {{ item }}
                  <i v-if="departmentVal == item" class="el-icon-check"></i>
                </li>
              </div>
            </transition>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "departmentName",
  props: ["departmentVal", "departmentOptions"], //重置时保持一致
  data() {
    return {
      options: [],
      maskShow: false,
      selectId: 0, //默认下划线显示省
      showMenu: true,
      menuList: [],
      menuVal: "",
      showDepartment: false,
      departmentList: []
      // departmentVal: '',
    };
  },
  watch: {
    departmentOptions() {
      if (this.departmentOptions.length > 0) {
        this.options = this.departmentOptions;
        this.options.forEach(item => {
          this.menuList.push(item.label);
        });
      }
    }
  },
  methods: {
    // 打开主遮罩
    openMask() {
      this.maskShow = true;
      document.body.style.overflow = "hidden";
    },
    // 关闭主遮罩
    closeMask(val) {
      //val为1时，为清空搜索内容
      this.maskShow = false;
      document.body.style.overflow = "auto";
      // 重置
      if (val == 1) {
        this.showMenu = true;
        this.selectId = 0;
        this.menuVal = "";
        this.showDepartment = false;
        this.departmentList = [];
        this.departmentVal = "";
      }
    },
    // 获取科室主菜单的值
    getMenuVal(val) {
      this.menuVal = val;
      this.selectId = 1; // 下划线跳到第二条，第二层科室
      this.showMenu = false;
      this.showDepartment = true;
      this.departmentList = []; // 清空
      this.departmentVal = "";
      this.options.forEach(item => {
        if (item.label == this.menuVal) {
          item.children.forEach(item_c => {
            this.departmentList.push(item_c.label);
          });
        }
      });
    },
    // 获取市的值
    getDepartmentVal(val) {
      this.departmentVal = val;
    },
    changeId(val) {
      if (val == 0) {
        this.selectId = 0;
        this.showMenu = true;
        this.showDepartment = false;
      } else if (val == 1) {
        this.selectId = 1;
        this.showMenu = false;
        this.showDepartment = true;
      }
    },
    confirmHoslital() {
      if (!this.departmentVal) {
        this.$dialog.toast({ mes: "请选择具体的科室" });
        return;
      }
      this.$emit("department-val", this.departmentVal);
      this.maskShow = false;
      document.body.style.overflow = "auto";
    },
    resetVal() {
      // 重置
      this.showMenu = true;
      this.selectId = 0;
      this.menuVal = "";
      this.showDepartment = false;
      this.departmentList = [];
      this.departmentVal = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.mask-hospital {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 400;
  background-color: rgba(0, 0, 0, 0.5);
  .hospital-content {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: #fff;
    z-index: 399;
    .select {
      display: flex;
      justify-content: space-between;
      height: 35px;
      background: #eee;
      span {
        line-height: 35px;
        font-size: 16px;
        color: #666;
        display: inline-block;
        width: 50%;
        text-align: center;
      }
      span:last-child {
        background: #409eff;
        color: #fff;
      }
    }
    .title {
      display: flex;
      justify-content: flex-start;
      padding-left: 0.5rem;
      padding-top: 0.15rem;

      .area {
        margin-right: 0.4rem;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 3.5rem;
        line-height: 26px;
        &.on {
          padding-bottom: 0.1rem;
          border-bottom: 2px solid #409eff;
        }
        span {
          font-weight: 700;
        }
      }
    }
    .content {
      padding-left: 0.5rem;
      padding-bottom: 0.25rem;
      font-size: 16px;
      line-height: 28px;
      overflow-y: auto;
      height: 90%;
      .active {
        color: #409eff;
      }
      li:first-child {
        margin-top: 0.1rem;
      }
    }
  }
}
.hospital {
  .input-btn {
    width: 100%;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
  }
  .click-btn {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 333;
    height: 40px;
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}
</style>
